<template>
  <div v-show="show" class="cp-popup">
    <div class="cp-popup-mask">
      <div v-click-outside="clickOutside" class="cp-popup-window">
        <div class="cp-popup-header">
          {{ title }}
          <img id="close_btn" v-if="close" @click="closePopUp" src="asset/image/icon/ease_close_btn.png">
          <i v-if="close" @click="closePopUp" class="fa fa-times close-btn" />
        </div>
        <div class="cp-popup-body">
          <slot />
        <slot name="button" />
        </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    close: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: false
    },
    clicked: {
      type: Boolean,
      default: false
    },
    enableClickOutside: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      show: false
    }
  },
  watch: {
    clicked: function() {
      this.show = !this.show
    }
  },
  methods: {
    clickOutside: function () {
      if (this.enableClickOutside) {
        this.closePopUp()
      }
    },
    closePopUp: function() {
      if (this.callback.toString().indexOf('_default()') === -1) {
        this.callback()
      } else {
        this.show = false
      }
    }
  }
}
</script>
